import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Add as AddIcon } from '@mui/icons-material';
import { GlobalButton, NavigateLinks, Authorize } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { childrenInventoryPageBreadcrumbs } from '../../config';
import { RequestsTable, SearchBar } from './components';
import { useRequestsFilter } from './hooks';
import { ROLES } from '@/components/security/AppRoles';

export const Requests = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenInventoryPageBreadcrumbs(navigate),
    []
  );

  const { filter, initialFilter, setFilter } = useRequestsFilter();

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks actualPage='Solicitudes' breadcrumbs={breadcrumbs} />
      <Authorize permission={ROLES.INVENTORY.leader}>
        <div className='flex gap-2.5 justify-end'>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={() => navigate('create')}
          >
            <AddIcon />
            Solicitar un equipo
          </GlobalButton>
        </div>
      </Authorize>
      <div className='flex justify-end gap-2.5'>
        <SearchBar
          filter={filter}
          initialFilter={initialFilter}
          search={(updatedFilter) => setFilter(updatedFilter)}
        />
      </div>
      <RequestsTable filter={filter} />
    </section>
  );
};

export default Requests;
